"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _view = require("../constants/view");

var _environment = require("../constants/environment");

var _Performance = _interopRequireDefault(require("./Performance"));

var PerformanceFulfiller = function PerformanceFulfiller(props) {
  return /*#__PURE__*/_react["default"].createElement(_Performance["default"], (0, _extends2["default"])({}, props, {
    view: _view.COMPONENT_VIEW.FULFILLER
  }));
};

PerformanceFulfiller.propTypes = {
  accessToken: _propTypes["default"].string.isRequired,
  environment: _propTypes["default"].oneOf([_environment.ENVIRONMENT.STAGING, _environment.ENVIRONMENT.PRODUCTION]),
  fulfiller: _propTypes["default"].shape({
    fulfillerId: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  }).isRequired,
  hideHeading: _propTypes["default"].bool,
  hideFilters: _propTypes["default"].bool,
  componentHeight: _propTypes["default"].string
};
var _default = PerformanceFulfiller;
exports["default"] = _default;